import React from 'react';
import {FileVisibilityHelper} from "../Files/FileVisibilityHelper";
import {useFileUpload} from "../../../Hooks/useFileUpload";

export const FileTableColumn = (props) => {
    const { Value, rowData } = props;
    
    const { fileUploadId } = rowData;
    
    const [fileUpload, loadUploadFile, downloadFile] = useFileUpload(fileUploadId);
    
    if(!rowData) {
        return <span>N/A</span>;
    }
    
    return <div className="cell-with-spaced-content">
        <a className="link-primary" onClick={() => downloadFile()} title={Value}>
            {Value}
        </a>
        <FileVisibilityHelper file={fileUpload} />
    </div>;
}
